import apiClient from './api';

// Chat Service
export const chatService = {
  // Lấy danh sách conversations
  getConversations: async (userId) => {
    try {
      const response = await apiClient.get(`/chats/conversations?userId=${userId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Lấy messages của một conversation
  getMessages: async (conversationId, page = 1, limit = 50) => {
    try {
      const response = await apiClient.get(`/chats/${conversationId}/messages?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Gửi message
  sendMessage: async (conversationId, message) => {
    try {
      const response = await apiClient.post(`/chats/${conversationId}/messages`, {
        content: message.content,
        type: message.type || 'text',
        attachments: message.attachments || []
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Tạo conversation mới
  createConversation: async (participants) => {
    try {
      const response = await apiClient.post('/chats/conversations', {
        participants
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create conversation using API's /Conversations endpoint (backend naming)
  createConversationApi: async (participants) => {
    try {
      // Backend expects a ClientId on the Conversation model; include current user's id
      const currentUser = JSON.parse(localStorage.getItem('user') || 'null');
      const clientId = currentUser?.id;
      const payload = { participants };
      if (clientId) payload.ClientId = clientId;
      const response = await apiClient.post(`/Conversations`, payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Đánh dấu message đã đọc
  markAsRead: async (conversationId, messageId) => {
    try {
      const response = await apiClient.put(`/chats/${conversationId}/messages/${messageId}/read`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Lấy AI chat response
  getAIResponse: async (message, options = {}) => {
    try {
      const currentUser = JSON.parse(localStorage.getItem('user') || 'null');
      const userId = currentUser?.id ? String(currentUser.id) : null;
      // Use existing backend AiController: POST /api/ai/chat
      const payload = {
        Text: message,
        UserId: userId
      };

      // Prefer conversation id provided in options, else use frontend-configured aiConversationId (stored in localStorage).
      const configuredAiConv = localStorage.getItem('aiConversationId');
      if (options?.conversationId) payload.ConversationId = options.conversationId;
      else if (configuredAiConv) payload.ConversationId = configuredAiConv;

      // If we still don't have a conversation id, try to ensure one via backend
      if (!payload.ConversationId) {
        try {
          const ensure = await apiClient.post('/ai/ensure');
          if (ensure?.data?.ConversationId) {
            payload.ConversationId = ensure.data.ConversationId || ensure.ConversationId;
            try { localStorage.setItem('aiConversationId', payload.ConversationId); } catch {}
          }
        } catch (e) {
          // ignore ensure failure — backend may be misconfigured
          console.debug('ai ensure failed', e?.response?.data || e.message || e);
        }
      }

      const response = await apiClient.post('/ai/chat', payload);
      // helpful debug log in browser console
      try { console.debug('chatService.getAIResponse response', response.data); } catch {}
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
